module.exports = window.PropTypes;